<template>
  <div :class="navTab === 'RichLevel' ? 'my_level my_level1' : 'my_level my_level2'" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.my_level')" placeholder safe-area-inset-top @click-left="goBack" left-arrow />
    <van-row>
      <van-col span="24" class="level_types">
        <van-tabs v-model="navTab" line-width="15px" background="unset">
          <van-tab :title="$t('column.rich_level')" name="RichLevel">
            <van-col span="22" offset="1" class="my_level_top">
              <van-col span="16">
                <van-col span="24">
                  <van-col span="6">
                    <van-image
                        width="12vw"
                        height="12vw"
                        round
                        fit="cover"
                        :src="userInfo.head_image"
                    />
                  </van-col>
                  <van-col span="18">
                    <van-col span="24" class="my_level_nick_name"> {{ userInfo.nick_name }}</van-col>
                    <van-col span="24" class="my_level_icon">
                      <img :src="require('../assets/img/level/wealth_level_'+ userInfo.wealth_level.level +'.png')"/>
                    </van-col>
                  </van-col>
                </van-col>
                <van-col span="24" class="my_level_progress">
                  <van-progress
                      :percentage="userInfo.wealth_percentage"
                      :show-pivot="false"
                      track-color	="#37394E"
                      color="#FFC8DD"
                  />
                </van-col>
                <van-col span="24" class="my_level_progress_text"> {{ $t('column.level_upgrade_requires_coins', {name: userInfo.next_wealth_level_name,coin: userInfo.wealth_up_score + ' ' + diamonds_name }) }}
                </van-col>
              </van-col>
              <van-col span="8" class="my_level_wealth_icon">
                <img :src="userInfo.wealth_icon" v-if="userInfo.wealth_icon"/>
              </van-col>
            </van-col>
            <van-col span="22" offset="1" class="my_level_label">{{ $t('column.level_label') }} </van-col>
            <van-col span="22" offset="1" class="my_level_label_text">{{ $t('column.rich_level_calculate') }}</van-col>
            <van-col span="22" offset="1" class="my_level_list_top">
              <van-steps direction="vertical" :active="userInfo.wealth_active" active-color="#43A3FC">
                <van-step v-for="item in wealth_icon_list" :key="item.id">
                  <div class="my_level_step">
                    <van-col span="17" offset="1" class="my_level_step_left">
                      <van-col span="24" class="my_level_step_title">{{ item.name }}   </van-col>
                      <van-col span="24" class="my_level_step_text">{{ item.level_coin_text }} </van-col>
                    </van-col>
                    <van-col span="6" class="my_level_ste_icon">
                      <img :src="require('../assets/img/level/wealth_level_'+ item.min_level +'.png')"/>
                    </van-col>
                  </div>
                </van-step>
              </van-steps>
            </van-col>
          </van-tab>
          <van-tab :title="$t('column.charm_level')" name="CharmLevel">
            <van-col span="22" offset="1" class="my_level_top">
              <van-col span="16">
                <van-col span="24">
                  <van-col span="6">
                    <van-image
                        width="12vw"
                        height="12vw"
                        round
                        fit="cover"
                        :src="userInfo.head_image"
                    />
                  </van-col>
                  <van-col span="18">
                    <van-col span="24" class="my_level_nick_name"> {{ userInfo.nick_name }}</van-col>
                    <van-col span="24" class="my_level_icon">
                      <img :src="require('../assets/img/level/charm_level_'+ userInfo.charm_level.level +'.png')"/>
                    </van-col>
                  </van-col>
                </van-col>
                <van-col span="24" class="my_level_progress">
                  <van-progress
                      :percentage="userInfo.charm_percentage"
                      :show-pivot="false"
                      track-color	="#37394E"
                      color="#FFC8DD"
                  />
                </van-col>
                <van-col span="24" class="my_level_progress_text"> {{ $t('column.level_upgrade_requires_coins', {name: userInfo.next_charm_level_name,coin: userInfo.charm_up_score + ' ' + diamonds_name }) }}
                </van-col>
              </van-col>
              <van-col span="8" class="my_level_wealth_icon">
                <img :src="userInfo.charm_icon" v-if="userInfo.charm_icon"/>
              </van-col>
            </van-col>
            <van-col span="22" offset="1" class="my_level_label">{{ $t('column.level_label') }} </van-col>
            <van-col span="22" offset="1" class="my_level_label_text">{{ $t('column.rich_level_calculate') }}</van-col>
            <van-col span="22" offset="1" class="my_level_list_top">
              <van-steps direction="vertical" :active="userInfo.charm_active" active-color="#43A3FC">
                <van-step v-for="item in charm_icon_list" :key="item.id">
                  <div class="my_level_step">
                    <van-col span="17" offset="1" class="my_level_step_left">
                      <van-col span="24" class="my_level_step_title">{{ item.name }}   </van-col>
                      <van-col span="24" class="my_level_step_text">{{ item.level_coin_text }} </van-col>
                    </van-col>
                    <van-col span="6" class="my_level_ste_icon">
                      <img :src="require('../assets/img/level/charm_level_'+ item.min_level +'.png')"/>
                    </van-col>
                  </div>
                </van-step>
              </van-steps>
            </van-col>
          </van-tab>
          <van-tab title="" name="" disabled></van-tab>
        </van-tabs>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import Toast from 'vant/lib/toast'
import axios from "axios"

export default {
  name: 'MyLevel',
  data() {
    return {
      diamonds_name: '',
      navTab: 'RichLevel',
      wealth_icon_list: [],
      charm_icon_list: [],
      userInfo: {
        wealth_level: {
          level: 0,
        },
        charm_level: {
          level: 0,
        },
        wealth_percentage: 0,
        charm_percentage: 0,
      },
      loading: false,
      finished: false,
      page: 1,
      loading_request: false, // 接口是否在请求中
      touchStartX: 0, // 触摸开始X坐标
      touchStartY: 0, // 触摸开始Y坐标
      touchEndX: 0, // 触摸结束X坐标
      touchEndY: 0, // 触摸结束Y坐标
      level_tabs: ['RichLevel', 'CharmLevel'] // 等级tab顺序
    }
  },
  created() {
    this.get_list()
  },
  methods: {
    get_list(){
      // 标记接口开始请求
      this.loading_request = true
      
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=my_level",{
        params:{uid: uid, token: token, date: this.date }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        this.loading_request = false // 标记接口请求完成
        
        console.log(res.data)
        if(res.data.status===1){
          this.userInfo = res.data.data.userinfo
          this.wealth_icon_list = res.data.data.wealth_icon_list
          this.charm_icon_list = res.data.data.charm_icon_list
          this.diamonds_name = res.data.data.diamonds_name
        }else{
          Toast(res.data.error)
        }
      }).catch(err => {
        toast.clear(); // 关闭加载提示
        // 请求失败也要恢复状态
        this.loading_request = false
        Toast(this.$t('other.network_error') || '网络错误')
      })
    },
    // 触摸开始
    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
    },
    // 触摸移动
    handleTouchMove(e) {
      this.touchEndX = e.touches[0].clientX
      this.touchEndY = e.touches[0].clientY
    },
    // 触摸结束
    handleTouchEnd() {
      // 如果接口正在请求中，禁止滑动切换
      if (this.loading_request) {
        return
      }
      
      const deltaX = this.touchEndX - this.touchStartX
      const deltaY = this.touchEndY - this.touchStartY
      
      // 判断是否为水平滑动（水平移动距离大于垂直移动距离，且大于50px）
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
        const currentIndex = this.level_tabs.indexOf(this.navTab)
        
        if (deltaX > 0) {
          // 向右滑动，切换到上一个tab
          if (currentIndex > 0) {
            this.navTab = this.level_tabs[currentIndex - 1]
            this.get_list()
          }
        } else {
          // 向左滑动，切换到下一个tab
          if (currentIndex < this.level_tabs.length - 1) {
            this.navTab = this.level_tabs[currentIndex + 1]
            this.get_list()
          }
        }
      }
    },
    goBack() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/my_level.vue